import React, { useState } from 'react';

import { Banner, Box, Spinner, Text } from '@betterment/samba-react';
import { SectionLayout } from '@betterment/style-closet-react';

import IntegrationConnectList from './IntegrationConnectList';
import IntegrationsBanner from './IntegrationsBanner';

import { SettingsLayout } from '../Settings/SettingsLayout';

export interface Notification {
  message: string;
  variant: 'info' | 'success' | 'warning' | 'critical';
}

const FirmIntegrationsPage: React.FC = () => {
  const [notification, setNotification] = useState<Notification | null>(null);

  return (
    <SettingsLayout activeTab="integrations">
      <SectionLayout>
        <SectionLayout.ContentWrapper>
          <IntegrationsBanner />
          {notification && (
            <Banner variant={notification.variant} css={{ mt: 'space.300', mb: 'space.0' }}>
              <Banner.Content>
                <Text as="p">{notification.message}</Text>
              </Banner.Content>
              <Banner.Close onClick={() => setNotification(null)} />
            </Banner>
          )}
          <React.Suspense
            fallback={
              <Box css={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'container.small' }}>
                <Spinner size="lg" />
              </Box>
            }
          >
            <IntegrationConnectList setNotification={setNotification} />
          </React.Suspense>
        </SectionLayout.ContentWrapper>
      </SectionLayout>
    </SettingsLayout>
  );
};

export default FirmIntegrationsPage;
